import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pdfViewerThumbnails.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, registerListener, unregisterAllListeners, fireEvent } from 'util/pubsub';
class PdfViewerThumbnails extends LightningElementSLDS {
  get style() {
    let returnVal = '';
    if (this.layout === 'Horizontal') {
      //horizontal style
      returnVal = 'display: flex;';
    } else if (this.layout === 'Vertical') {
      //vertical style
      returnVal = 'display: grid;';
    } else {
      //default style / grid style
      returnVal = 'display: inline-block;';
    }
    return returnVal;
  }
  rotateSpecificPage(indexOfPageToRotate) {
    let self = this;
    let thumbnailToRotate = self.template.querySelectorAll("div.thumbnail")[indexOfPageToRotate];

    //rotate thumbnail function will fire the SHOW_PDF_PAGE event
    self.rotateThumbnail(thumbnailToRotate, indexOfPageToRotate);

    // window.___thumbnails_pageInfo___.curSelection.forEach(canvas => {
    //     canvas.classList.remove('currently-selected');
    //     canvas.classList.add('selected');
    // });
  }
  rotateThumbnail(thumbnail, thumbnailIndex) {
    let self = this;
    let canvas = thumbnail.querySelector('canvas');
    //let currentSelectionArr = this.template.querySelector('[data-id="selectionText"]').value.split(',');
    let thumbnailCanvas = thumbnail.querySelector("canvas");
    // If the current thumbnail was selected, preserve the currently-selected class
    let addClassToRotatedCanvas = thumbnailCanvas.className.indexOf("currently-selected") >= 0 ? true : false;

    // let selectedthumbanilCanvas= $(thumbnailCanvas.className).prop("selected");

    thumbnail.removeChild(canvas);
    window.___thumbnails_pageInfo___.pageRotationInfo[thumbnailIndex] = self.addRotation(window.___thumbnails_pageInfo___.pageRotationInfo[thumbnailIndex]);
    self.___pdfDoc___.getPage(thumbnailIndex + 1).then(page => self.renderThumbnail(page, thumbnailIndex + 1)) //, currentSelectionArr
    .then(canvas => {
      //outer variables not accessible here, refetch the thumnbail for current canvas based on canvas index
      //canvas index starts from 1, subtract from canvas index to get right thumbnail.
      let currentPageNumber = thumbnailIndex + 1;
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "thumbnails",
          pageNumber: currentPageNumber,
          pageRotation: window.___thumbnails_pageInfo___.pageRotationInfo[currentPageNumber - 1] || 0
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(self.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      let thumbnail = self.template.querySelectorAll("div.thumbnail")[canvas.idx - 1];
      let actionsDiv = thumbnail.querySelector(".actions");
      if (!actionsDiv) {
        actionsDiv = self.appendActionsToThumbnail(thumbnail, canvas.idx);
      }
      // let buffer = "";
      // if(this.template.querySelector(".currently-selected")){
      //     this.template.querySelector(".currently-selected").classList.remove('currently-selected');
      // }
      // window.___thumbnails_pageInfo___.curSelection.forEach(canvas => {
      //     canvas.classList.remove("currently-selected");
      //     canvas.classList.add('selected');
      //     if (buffer) {
      //         buffer += ",";
      //     }
      //     buffer += canvas.idx;
      // });
      // if(buffer){ // ORV 240513 check if buffer is not null as selected input text is null on rotation
      //     this.template.querySelector('[data-id="selectionText"]').value = buffer;
      // }
      if (addClassToRotatedCanvas) {
        canvas.classList.add("currently-selected");
      }
      thumbnail.insertBefore(canvas, actionsDiv);
    });
  }
  appendActionsToThumbnail(thumbnail, canvasIndex) {
    //CRN240402 No initial page selection is supported
    let self = this;
    let actionsDiv = thumbnail.querySelector(".actions");
    if (!actionsDiv) {
      actionsDiv = document.createElement("div");
      actionsDiv.setAttribute("class", "actions");

      //refresh icon
      let refreshButton = document.createElement("span");
      refreshButton.innerHTML = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 496.156 496.156" style="enable-background:new 0 0 496.156 496.156;" xml:space="preserve" width="18px" height="18px">                <g>                    <path style="fill:#000000;" d="M428.243,172.149c-10.348,0.023-20.694,0.054-31.042,0.077                        c-23.272-52.177-68.95-89.871-126.649-98.91c-64.287-10.071-125.816,19.788-162.504,72.312                        c-16.296,23.326,22.003,45.165,38.16,22.034c50.317-72.037,157.757-65.527,201.907,4.686c-9.559,0.022-19.118,0.046-28.678,0.068                        c-2.674,0.008-4.574,1.197-5.749,2.877c-1.92,2.058-2.65,5.072-0.639,8.186c18.204,28.25,36.408,56.499,54.616,84.745                        c3.061,4.747,9.663,4.708,12.696-0.046c18.062-28.338,36.126-56.675,54.188-85.013C437.538,178.48,433.602,172.135,428.243,172.149                        z"></path>                    <path style="fill:#000000;" d="M350.353,327.224c-49.927,71.49-156.108,65.63-200.886-3.049c9.161-0.022,18.322-0.046,27.484-0.068                        c2.666-0.008,4.563-1.19,5.741-2.865c1.924-2.059,2.658-5.072,0.646-8.197c-18.2-28.246-36.405-56.499-54.609-84.741                        c-3.056-4.751-9.662-4.712-12.695,0.046c-18.063,28.334-36.13,56.671-54.196,85.009c-2.987,4.689,0.948,11.032,6.308,11.017                        c10.669-0.027,21.337-0.054,32.006-0.08c23.498,51.319,68.777,88.332,125.865,97.275c64.287,10.072,125.816-19.784,162.496-72.312                        C404.806,325.928,366.508,304.09,350.353,327.224z"></path></g></svg>';
      refreshButton.addEventListener("click", event => {
        /*
         * index passed to rotateSpecificPage function should be starting from 0
         * canvas idx (canvasIndex) begins from 1
         * subtract 1 from canvas idx when passing to 
         **/
        self.rotateSpecificPage(canvasIndex - 1);
        self.broadcastPageNumbersWithRotation();
      });
      actionsDiv.appendChild(refreshButton);

      //page number
      let pageNumber = document.createElement("span");
      pageNumber.innerHTML = canvasIndex;
      //pageNumber.style = "padding-left: 25%;";
      pageNumber.setAttribute('class', 'pageNumber');
      //pageNumber.style = "margin-left: auto; margin-right: auto;";
      actionsDiv.appendChild(pageNumber);
      let checkbox = document.createElement('input');
      //CRN240401 Checkboxes are not clickable. They are only for feedback purposes.
      checkbox.disabled = true;
      checkbox.setAttribute("type", "checkbox");
      actionsDiv.appendChild(checkbox);
      thumbnail.appendChild(actionsDiv);
    }
    return actionsDiv;
  }
  addRotation(currentRotation) {
    return (currentRotation + 90) % 360;
  }
  constructor() {
    super();
    // // Add SLDS CSS
    // let _stylePath = 'resources/pdf_viewer.css';
    // const styles = document.createElement('link');
    // styles.href = _stylePath;
    // styles.rel = 'stylesheet';
    // this.template.appendChild(styles);
    this.snippetId = void 0;
    this.parentLoadsPdf = false;
    this.multiSelect = false;
    this.selectString = "1";
    this.selectPagesOnLoad = true;
    //AHS250320 (ZP-999) - adding a flag to select pages by default only for the first PDF
    // DEFAULT_SCALE = 1.0; //SHR191114 show full size for a better zoom experience
    this.___pdfDoc___ = void 0;
    this.selectPageNumber = void 0;
    this.isLocalFileUpload = void 0;
    this.localFileData = void 0;
    this.pageClickedCallFromCheckbox = false;
    this.previousSelectedPageNum = 1;
    this.areAllThumbnailsSelected = true;
    //menu item disabled / hidden by default
    this.areAllThumbnailsDeselected = true;
    //menu item disabled / hidden by default
    this.canvasSizes = {
      "Small": 0.5,
      "Medium": 1,
      "Large": 2
    };
    //stores rotation characters for 0 deg, 90 deg, 180 deg, 270 deg
    this.rotationDegreeToRotationCode = {
      "0": "",
      "90": "r",
      "180": "u",
      "270": "c"
    };
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(s) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    // zpServer = "https://devcrn.zpaper.com/";
    this.__g_zPDF_formHelper__ = void 0;
  }
  connectedCallback() {
    window.___thumbnails_pageInfo___ = {
      curSelection: [],
      pageRotationInfo: []
    }; // Make this global so that other components can retrieve page selection data.
    let self = this;
    console.log('@@@@ Thumbnails is added to DOM component width = ' + this.flexipageRegionWidth + ' @@@@');
    registerListener(eventTypes.PDF_LOADED, this.handlePdfLoaded, this);
    registerListener(eventTypes.SHOW_THUMBNAILS, this.handleShowPdfThumbnails, this);
    registerListener(eventTypes.CHECK_THUMBNAIL_CHECKBOX, this.handleCheckPdfThumbnails, this);
    registerListener(eventTypes.ROTATE_CURRENT_PAGE, this.rotatePdfThumbanils, this);
    registerListener(eventTypes.LOCAL_FILE_UPLOAD, localFileUploadEvent => {
      console.log("LOCAL_FILE_UPLOAD handled in thumbnails");
      self.isLocalFileUpload = true;
      self.localFileData = localFileUploadEvent.localFileData;
      self.loadPDF();
    }, self);
    registerListener(eventTypes.SHOW_PDF_PAGE, self.handleShowPdfPage, self);
    registerListener(eventTypes.PDF_PAGE_CHANGED, self.handlePdfPageChange, self);

    //if parent does not load the pdf , lead the pdf by self
    if (!this.parentLoadsPdf) {
      console.log("**************** parent not loading pdf *******************");
      this.loadPDF();
    }
  }
  broadcastPageNumbersWithRotation() {
    let selectedPageNumbers = [];
    let selectedPageNumbersWithoutRotation = [];
    //__g__allPageRotation stores the rotation of pages and use to maintain its state while redendering the page
    __g__allPageRotation = window.___thumbnails_pageInfo___.pageRotationInfo;
    if (window.___thumbnails_pageInfo___.curSelection.length === 0) {
      __g_pageRotation = window.___thumbnails_pageInfo___.pageRotationInfo;
    }
    __g_selectedNonSelectedPageRotation = window.___thumbnails_pageInfo___.pageRotationInfo;
    window.___thumbnails_pageInfo___.curSelection.forEach(canvas => {
      selectedPageNumbersWithoutRotation.push(canvas.idx);
      if (window.___thumbnails_pageInfo___.pageRotationInfo[canvas.idx - 1] === 90) {
        selectedPageNumbers.push(canvas.idx + "r");
      } else if (window.___thumbnails_pageInfo___.pageRotationInfo[canvas.idx - 1] === 180) {
        selectedPageNumbers.push(canvas.idx + "u");
      } else if (window.___thumbnails_pageInfo___.pageRotationInfo[canvas.idx - 1] === 270) {
        selectedPageNumbers.push(canvas.idx + "c");
      } else {
        console.log("Coming inside else block");
        selectedPageNumbers.push(canvas.idx);
      }
    });
    let rotevent = new CustomEvent(eventTypes.BROADCAST_SELECTED_PAGE_NUM, {
      detail: {
        selectedPageNumbers: selectedPageNumbersWithoutRotation,
        selectedPageNumbersWithRotation: selectedPageNumbers.toString()
      }
    });
    fireEvent(this.pageRef, eventTypes.BROADCAST_SELECTED_PAGE_NUM, rotevent);
    this.template.querySelector('[data-id="selectionText"]').setAttribute('value', selectedPageNumbers.toString());
    __g_selectedPages = selectedPageNumbers.toString();
    return selectedPageNumbers.toString();
  }
  rotatePdfThumbanils(evt) {
    this.rotateSpecificPage(evt.detail.pageNumber);
  }
  disconnectedCallback() {
    unregisterAllListeners(this);
  }
  handlePdfLoaded(evt) {
    let self = this;
    try {
      //if(evt.detail.success) {
      //    self.___pdfDoc___ = evt.detail.doc;
      //    let buffer = "", maxPages = evt.detail.doc.numPages;
      //    self.renderThumbnails(evt.detail.doc);
      //}
      self.isLocalFileUpload = true;
      self.localFileData = evt.detail.doc;
      self.loadPDF();
    } catch (err) {
      console.error("Exception while loading PDF: " + err);
    }
  }
  handleShowPdfThumbnails(evt) {
    console.log("formViewerThumbnails: Event received => ", evt);
    this.loadPDF(evt.detail);
  }
  handleCheckPdfThumbnails(evt) {
    console.log("formViewerThumbnails: Event received => ", evt);
    const checkedPages = evt.detail.checkedThumbnails;
    checkedPages.split(",").forEach(pageNum => {
      pageNum = pageNum.trim();
      $(this.template.querySelector(`[data-id='canvas_${pageNum}']`)).parent().find("input:checkbox").attr("checked", "true");
    });
  }
  parseHostFromUrl(protocol, url) {
    if (__g_protocol === 'file') {
      return 'file';
    }
    url = decodeURIComponent(url); // decode if necessary...
    let idxBegin = url.indexOf("://") > 0 ? url.indexOf("://") + 3 : 0;
    let idxEnd = url.indexOf('/', idxBegin);
    if (idxEnd < 0) {
      return url.substring(idxBegin);
    }
    return url.substring(idxBegin, idxEnd);
  }
  loadPDF(snippetId) {
    try {
      window.___thumbnails_pageInfo___.curSelection = [];
      let self = this;
      console.log("@@@ snippetId = " + snippetId);
      console.log("@@@ __g_requestedPdf = " + __g_requestedPdf);
      let pdfUrl = isApiServerAvailable ? __g_zApiURL + `viewForm?id=${snippetId}` : `/kb/client/wget.jsp?get=${__g_requestedPdf}`; //added a flag to check if we are working with an api server
      if (__g_requestedPdf) {
        pdfUrl = __g_zApiURL + `fetch/getUrl?get=${__g_requestedPdf}`;
        let host = this.parseHostFromUrl(__g_protocol, __g_requestedPdf);
        console.log("Requested PDF host => " + host);
        console.log("Host that served up this UI => " + __g_hostname);
        if ('file' === host || host === __g_hostname) {
          // Just pull the url directly using AJAX if it is coming from the same host that served up this UI.
          // I don't think the local file will work because of cross-site protections, but we'll see.
          pdfUrl = decodeURIComponent(__g_requestedPdf);
        }
      }
      console.log("Pulling PDF from url => " + pdfUrl);

      //checking if local file is uploaded
      if (self.isLocalFileUpload) {
        pdfUrl = self.localFileData;
        self.isLocalFileUpload = false;
      }
      console.log("Pulling thumbnails from url => " + pdfUrl);
      let loadingTask = pdfjsLib.getDocument(pdfUrl);
      loadingTask.promise.then(function (doc) {
        self.___pdfDoc___ = doc;
        let buffer = "",
          maxPages = doc.numPages;
        self.renderThumbnails(doc);
      }).catch(error => console.log("Exception while loading PDF: " + error.message));
    } catch (e) {
      console.log("Error loading pdf page: " + e);
    }
  }
  renderThumbnails(doc) {
    let self = this;
    self.___pdfDoc___ = doc;
    let buffer = "",
      maxPages = doc.numPages;
    // self.__pageInfo___.pageCount = doc.numPages;
    console.log("Number of pages in document = " + maxPages);
    let thumbNailsPanel = self.template.querySelector('.thumbnails');
    // clear out any previous child nodes
    let child = thumbNailsPanel.lastElementChild;
    while (child) {
      thumbNailsPanel.removeChild(child);
      child = thumbNailsPanel.lastElementChild;
    }

    // Create the selected pages feedback area.
    //<div class="select-feedback">Selcted: <input class="selection-text" type="text" disabled="disabled">
    let selectFeedbackDiv = document.createElement("div");
    selectFeedbackDiv.innerHTML = 'Selected: <input class="selection-text" data-id="selectionText" type="text" disabled="disabled">';
    thumbNailsPanel.appendChild(selectFeedbackDiv);
    // on hover display selected pages
    /* selectFeedbackDiv.addEventListener('click', function() {
         var selectionTextElement = this.querySelector('[data-id="selectionText"]');
         var $title = $(selectionTextElement).find(".title");
         if (!$title.length) {
             $(selectionTextElement).append('<span class="title">' + selectionTextElement.title + '</span>');
         } else {
             $title.remove();
         }
     }); */
    let pages = [];
    window.___thumbnails_pageInfo___.curSelection = [];
    window.___thumbnails_pageInfo___.pageRotationInfo = [];
    for (let i = 1; i <= doc.numPages; i++) {
      pages.push(pages.length + 1);
    }

    //const urlParams = new URLSearchParams(window.location.search); //ORV 230424 
    console.log('**urlParams**', urlParams); //we should get urlParams from index html
    //AHS250320 (ZP-999) - not supporting rotation (adding rotation to pages would throw error)
    //AHS250320 (ZP-999) - setting default page selection
    let selectedPage = "1";
    // let selectedPagesArr = [1]; //always select the first page by default

    //AHS250320 (ZP-999) - updating default page selection if "pages" param is specified update default selection
    if (self.selectPagesOnLoad) {
      self.selectPagesOnLoad = false;
      selectedPage = urlParams.get('page') || "1";
      selectedPage = self.getFirstPageNumber(selectedPage, maxPages); //based on code review feedback we are going to ignore the rest of selection and just use the first page
      // selectedPages = selectedPagesArr.join(",");
    }

    //AHS250320 (ZP-999) - set the default selection on text field
    self.template.querySelector('[data-id="selectionText"]').value = selectedPage;
    self.template.querySelector('[data-id="selectionText"]').title = selectedPage;
    var thumbnailPromises = Promise.all(pages.map(function (i) {
      let thumbNailDiv = document.createElement("div");
      thumbNailDiv.className = "thumbnail";
      thumbNailDiv.style.padding = "2px";
      thumbNailsPanel.appendChild(thumbNailDiv);
      doc.getPage(i).then(function (page) {
        let vp = page.getViewport(1);
        console.log("AHS240613 - got the page : ", page, vp); //AHS240613
        window.___thumbnails_pageInfo___.pageRotationInfo.push(page.rotate); //ORV240208 store the rotation from metadata
        let rotation = window.___thumbnails_pageInfo___.pageRotationInfo[i - 1] || 0;
        let canvas = document.createElement("canvas");
        //AHS250320 (ZP-999) - is the page number for current page is a part of seletedPageArr add the currently-selected class to thumbnail canvas
        if (i == selectedPage) {
          canvas.classList.add("currently-selected");
        }

        //self.previousSelectedPageNum = 1; //AHS250320 (ZP-999)
        self.previousSelectedPageNum = selectedPage; //AHS250320 (ZP-999)
        // keep 8.5 x 11 aspect ratio
        //AHS230613 - Added the static height and width of the canvas (start) this looks like duplicate code and we have scope for merging it, this is a quick fix
        console.log("AHS240613 - setting scale and rotation");
        let scale = 0;
        if (rotation === 0 || rotation === 180) {
          //vertical canvas layout
          canvas.height = vp.width < vp.height ? 109 : 84;
          canvas.width = vp.width < vp.height ? 84 : 109;
          scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
          console.log(`AHS240613 (vertical): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
        } else {
          //horizontal canvas layout
          canvas.width = vp.width < vp.height ? 109 : 84;
          canvas.height = vp.width < vp.height ? 84 : 109;
          scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
          console.log(`AHS240613 (horizontal): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
        }
        //AHS230613 - Added the static height and width of the canvas (end)

        canvas.idx = i;
        canvas.id = 'canvas_' + i;
        canvas.setAttribute('data-id', 'canvas_' + i);
        canvas.addEventListener("click", function (evt) {
          self.pageClicked.call(self, evt, this);
        });
        console.log("Rendering canvas for page ", i);
        return page.render({
          canvasContext: canvas.getContext("2d"),
          viewport: page.getViewport(scale, rotation) //AHS240614 - added rotation
        }).promise.then(function () {
          return canvas;
        });
      }).then(function (canvas) {
        console.log("renderThumbnails canvas");
        thumbNailDiv.appendChild(canvas);
        self.appendActionsToThumbnail(thumbNailDiv, canvas.idx); //ORV250410 append actions to thumbnails
        //AHS250320 (ZP-999) - display the first page from the selected page array
        if (selectedPage == i) {
          self.handleShowPdfPage(null, canvas);
        }
        self.broadcastPageNumbersWithRotation(); //ORV240312 call broadcastPageNumbersWithRotation function after appeding actions as all pages are selected by default
        // Make sure that we populate curSelection.
        if (canvas.classList.contains("currently-selected")) {
          window.___thumbnails_pageInfo___.curSelection.push(canvas);
          // We will receive the canvases out of order, make sure they are sorted correclty.
          window.___thumbnails_pageInfo___.curSelection.sort((a, b) => a.idx - b.idx);
          console.log("curSelection = ", window.___thumbnails_pageInfo___.curSelection);
        }
      }).catch(error => {
        console.log("Exception while loading PDF: " + error.message);
      });
    }));

    //AHS260819+Claude: render import-pages button, visible only when window.__showImportPagesBtn is truthy
    self.renderImportButton(thumbNailsPanel);
    return thumbnailPromises;
  }

  //AHS260819+Claude: minimal "+" button — visibility driven by global var, click delegates to global callback
  renderImportButton(container) {
    let existing = container.querySelector('.import-pages-btn');
    if (existing) existing.remove();
    let btn = document.createElement("button");
    btn.className = "import-pages-btn";
    btn.innerHTML = "+";
    btn.title = "Import pages from another PDF";
    btn.style.display = window.__showImportPagesBtn ? "" : "none";
    btn.addEventListener("click", () => {
      if (typeof window.__onImportPages === "function") window.__onImportPages();
    });
    container.appendChild(btn);
  }

  /**
   * Converts a page value string to an array of individual page numbers
   * @param {string} pageValueString - The page selection string
   * @param {number} maxPages - Maximum number od pages in the document
   * @returns {number[]} Array of individual page numbers in the specified order
   */
  getFirstPageNumber(pageValueString, maxPages) {
    let firstPageNumber = 1;
    if (!pageValueString || pageValueString.trim() === '') {
      return firstPageNumber; // Default to page 1 if no page value is specified
    }

    // Split by comma
    const sections = pageValueString.split(',');
    for (const section of sections) {
      if (section.includes('-')) {
        // Handle range (e.g., "5-8" or "8-5")
        const [start, end] = section.split('-').map(num => parseInt(num, 10));
        firstPageNumber = start;
      } else if (section.trim() !== '') {
        // Handle single page (e.g., "3")
        firstPageNumber = parseInt(section, 10);
      }
      break; //we are only interested in first page
    }
    if (1 <= firstPageNumber && firstPageNumber <= maxPages) {
      return firstPageNumber;
    }
    return 1;
  }
  removeThumbnails(nonPdfFile) {
    let self = this;
    if (nonPdfFile) {
      let thumbNailsPanel = self.template.querySelector('.thumbnails');
      let child = thumbNailsPanel.lastElementChild;
      while (child) {
        thumbNailsPanel.removeChild(child);
        child = thumbNailsPanel.lastElementChild;
      }
    }
  }
  pageClicked(evt, ele, onlySelectThumbnail) {
    console.log("pageClicked: Page " + ele.idx + " clicked! " + window.___thumbnails_pageInfo___.pageRotationInfo[ele.idx - 1]);
    if (!onlySelectThumbnail) {
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "thumbnails",
          pageNumber: ele.idx,
          pageRotation: window.___thumbnails_pageInfo___.pageRotationInfo[ele.idx - 1] || 0
        },
        bubbles: true,
        cancelable: true
      });

      //do fire events if they are received from another source
      if (!(evt.detail && evt.detail.source)) {
        fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      }
    }
    let curSelectionBuffer = this.template.querySelector('[data-id="selectionText"]').value;
    if (evt) {
      if (!(evt.shiftKey || evt.ctrlKey)) {
        window.___thumbnails_pageInfo___.curSelection = []; // reset our curSelection list
        curSelectionBuffer = ele.idx;
        const oldSelection = this.template.querySelectorAll(".currently-selected");
        // Clear out the previous selection.
        this.clearSelection(oldSelection);
        ele.classList.add("currently-selected");
        window.___thumbnails_pageInfo___.curSelection.push(ele);
      } else {
        console.log("Inside page click shift or ctrl");
        if (evt.ctrlKey) {
          curSelectionBuffer = this.addOrRemoveSelectionPage(curSelectionBuffer, ele.idx, !ele.classList.contains('currently-selected'));
          $(ele).toggleClass('currently-selected');
          if ($(ele).hasClass('currently-selected')) {
            window.___thumbnails_pageInfo___.curSelection.push(ele); // add to the selected list
          } else {
            // remove from the selected list
            window.___thumbnails_pageInfo___.curSelection = window.___thumbnails_pageInfo___.curSelection.filter(canvas => ele.idx !== canvas.idx);
          }
        } else {
          // shift key pressed
          let lastSelectedPage = this.previousSelectedPageNum;
          window.___thumbnails_pageInfo___.curSelection = []; // reset our curSelection list
          curSelectionBuffer = "";
          if (lastSelectedPage > 0) {
            let curPage = ele.idx;
            const beginPage = Math.min(curPage, lastSelectedPage);
            const endPage = Math.max(curPage, lastSelectedPage);
            const oldSelection = this.template.querySelectorAll(".currently-selected");
            this.clearSelection(oldSelection);
            for (let i = beginPage; i <= endPage; i++) {
              const ele2 = this.template.querySelector(`[data-id=\"canvas_${i}\"]`);
              ele2.classList.add("currently-selected");
              if (curSelectionBuffer.length > 0) {
                curSelectionBuffer += ',';
              }
              curSelectionBuffer += i;
              window.___thumbnails_pageInfo___.curSelection.push(ele2);
            }
          } else {
            // There was no previous selection.
            ele.classList.add("currently-selected");
            curSelectionBuffer = ele.idx;
            window.___thumbnails_pageInfo___.curSelection.push(ele);
          }
        }
      }
    }
    this.previousSelectedPageNum = ele.idx;
    this.template.querySelector('[data-id="selectionText"]').value = curSelectionBuffer;
    this.template.querySelector('[data-id="selectionText"]').title = curSelectionBuffer;
  }
  clearSelection(selection) {
    if (selection) {
      for (let i = 0; i < selection.length; i++) {
        selection[i].classList.remove("currently-selected");
      }
    }
  }
  addOrRemoveSelectionPage(selection, pageNumber, add) {
    // We'll always first remove the number from the selection.
    let newSelection = selection.split(',').filter(val => val.trim() != pageNumber).join(',');
    if (add) {
      if (newSelection.length > 0) {
        newSelection += ',';
      }
      newSelection += pageNumber;
    }
    return newSelection;
  }
  renderThumbnail(page, i, currentSelectedPageCodes) {
    let self = this;
    let rotation = window.___thumbnails_pageInfo___.pageRotationInfo[i - 1] || 0;
    let vp = page.getViewport(1);
    let originalPageRotation = vp.rotation;

    //        console.log("AHS240613 - got the page : " , page, vp);//AHS240613
    //        console.log(`AHS240613 (originalPageRotation): ${originalPageRotation}`);
    //        console.log(`AHS240613 (rotation): ${rotation}`);

    let canvas = document.createElement("canvas");
    canvas.classList.add("thumbCanvas");
    let presentPages = [];
    let indexOfCurrentCanvas;
    window.___thumbnails_pageInfo___.curSelection.forEach(temp => {
      presentPages.push(temp.idx);
      if (temp.idx === i) {
        indexOfCurrentCanvas = window.___thumbnails_pageInfo___.curSelection.indexOf(temp);
      }
    });
    if (presentPages.includes(i)) {
      window.___thumbnails_pageInfo___.curSelection[indexOfCurrentCanvas] = canvas;
    }
    // keep 8.5 x 11 aspect ratio
    //canvas.width = 84;
    //canvas.height = 109;
    let scale = 0;
    if (rotation === 0 || rotation === 180) {
      //vertical canvas layout
      const canvasSize = self.thumbnailSize ? self.canvasSizes[self.thumbnailSize] : self.canvasSizes.Medium;
      canvas.height = vp.width < vp.height ? 109 * canvasSize : 84 * canvasSize;
      canvas.width = vp.width < vp.height ? 84 * canvasSize : 109 * canvasSize;
      scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
      //ORV240614 - checking the original orientation of the page and determinig the canvas height and width
      if (originalPageRotation === 90 || originalPageRotation === 270) {
        scale = Math.min(canvas.width / vp.height, canvas.height / vp.width);
      }
      //            console.log(`AHS240613 (vertical): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
      //            console.log(`AHS240613 (horizontal): ${canvas.style}`);
    } else {
      //horizontal canvas layout
      const canvasSize = self.thumbnailSize ? self.canvasSizes[self.thumbnailSize] : self.canvasSizes.Medium;
      canvas.width = vp.width < vp.height ? 109 * canvasSize : 84 * canvasSize;
      canvas.height = vp.width < vp.height ? 84 * canvasSize : 109 * canvasSize;
      canvas.style = "margin-bottom: " + 12.5 * canvasSize + "px; margin-top:  " + 12.5 * canvasSize + "px;";
      //ORV240614 - checking the original orientation of the page and determinig the canvas height and width
      scale = Math.min(canvas.width / vp.height, canvas.height / vp.width); //AHS240613 / ORV240614
      if (originalPageRotation === 90 || originalPageRotation === 270) {
        scale = Math.min(canvas.width / vp.width, canvas.height / vp.height); //AHS240613 / ORV240614
      }
      //            console.log(`AHS240613 (horizontal): ${canvas.width} / ${vp.width}, ${canvas.height} / ${vp.height}; Scale: ${scale}`);
      // console.log(`AHS240613 (horizontal): ${canvas.width} / ${vp.height}, ${canvas.height} / ${vp.width}; Scale: ${scale}`);
      // console.log(`AHS240613 (horizontal): ` + "margin-bottom: " + (12.5 * canvasSize) + "px; margin-top:  " + (12.5 * canvasSize) + "px;");
      //CRN250311 What is up with this?
      // scale = 0.13725490196078433;
    }
    canvas.idx = i;
    canvas.id = 'canvas_' + i;
    canvas.setAttribute('data-id', 'canvas_' + i);
    canvas.addEventListener("click", function (evt) {
      self.pageClicked.call(self, evt, this);
      // const pageEvent = new CustomEvent('thumbnailclick', {
      //     detail: this.idx
      // });
      // self.dispatchEvent(pageEvent);
    });
    //let scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);
    return page.render({
      canvasContext: canvas.getContext("2d"),
      viewport: page.getViewport(scale, rotation)
    }).promise.then(function () {
      return canvas;
    });
  }
  renderedCallback() {
    if (__g_isMobile && !__g_isThumbnailCmpLoaded) {
      // change the background for thumbnail in mobile
      this.template.querySelectorAll("div.thumbnails")[0].style.backgroundColor = "#3a8dc9";
    }
    __g_isThumbnailCmpLoaded = true;
  }
  handleShowPdfPage(evt, canvas) {
    //the if condition checks if the event is fired from thumbnail itself. If yes , then it ignores the event
    if (evt && evt.detail.source != "thumbnails" && evt.detail.pageNumber) {
      console.log("show pdf page event received in thumnail component, index : " + evt.detail.pageNumber);
      let canvasId = "#canvas_" + evt.detail.pageNumber;
      let ele = this.template.querySelector(canvasId);
      this.pageClicked(evt, ele);
    } else if (canvas) {
      //ORV 240423 display the 1st value from pages param as selected page
      //AHS250320 (ZP-999) - start (reduced code to only fire an event)
      let event = new CustomEvent(eventTypes.SHOW_PDF_PAGE, {
        detail: {
          source: "thumbnails",
          pageNumber: parseInt(canvas.idx),
          pageRotation: 0
        },
        bubbles: true,
        cancelable: true
      });
      fireEvent(this.pageRef, eventTypes.SHOW_PDF_PAGE, event);
      //AHS250320 (ZP-999) - end
    }
  }
  handlePdfPageChange(evt) {
    //the if condition checks if the event is fired from thumbnail itself. If yes , then it ignores the event
    if (evt.detail.source != "thumbnails" && evt.detail.pageNumber) {
      console.log("show pdf page event received in thumnail component, index : " + evt.detail.pageNumber);
      let canvasId = "#canvas_" + evt.detail.pageNumber;
      let ele = this.template.querySelector(canvasId);
      this.pageClicked(evt, ele, true);
    }
  }
}
_registerDecorators(PdfViewerThumbnails, {
  publicProps: {
    snippetId: {
      config: 0
    },
    parentLoadsPdf: {
      config: 0
    },
    multiSelect: {
      config: 0
    }
  },
  publicMethods: ["removeThumbnails"],
  track: {
    selectString: 1
  },
  fields: ["selectPagesOnLoad", "___pdfDoc___", "selectPageNumber", "isLocalFileUpload", "localFileData", "pageClickedCallFromCheckbox", "previousSelectedPageNum", "areAllThumbnailsSelected", "areAllThumbnailsDeselected", "canvasSizes", "rotationDegreeToRotationCode", "pageRef", "__g_zPDF_formHelper__"]
});
export default _registerComponent(PdfViewerThumbnails, {
  tmpl: _tmpl
});